import { motion, Variants } from 'framer-motion'
import React, { CSSProperties, FunctionComponent } from 'react'
import clsx from 'clsx'
import styles from './ColoredTabs.module.sass'
import { setLightness } from 'polished'
import SideMark from '../../etc/SideMark/SideMark'

const tabVariants: Variants = {
    hidden: {
        width: 0,
        opacity: 0,
        marginRight: 0,
    },
    open: {
        width: 'auto',
        opacity: 1,
        marginRight: '4px',
    },
    minimal: {
        width: 4,
        opacity: 1,
        marginRight: '4px',
    }
}

interface Props {
    className?: string,
    color: string,
    active?: boolean,
    minimal?: boolean,
    onClick?: () => void,
}

const ColoredTab: FunctionComponent<Props> = props => <motion.div
    className={clsx(props.className, styles.tab, {[styles.active]: props.active})}
    variants={tabVariants}
    initial={props.minimal? 'minimal': 'initial'}
    animate={(!props.active && props.minimal)? 'minimal': 'open'}
    exit={'initial'}
    onClick={props.onClick}
    style={{'--color': setLightness(0.95, props.color)} as CSSProperties}
>
    <div className={styles.content}>
        <SideMark color={props.color}/>
        {props.children}
    </div>
</motion.div>

export default ColoredTab